import React from "react";
import "../assets/css/Header.css";
import HeaderOption from "./HeaderOption";
import SearchIcon from "@material-ui/icons/Search";
import HomeIcon from "@material-ui/icons/Home";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import ChatIcon from "@material-ui/icons/Chat";
import NotificationsIcon from "@material-ui/icons/Notifications";

import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";

function Header() {
	const user = useSelector(selectUser);

	return (
		<div className="header">
			<div className="header__left">
				<img
					src="https://www.flaticon.com/svg/static/icons/svg/174/174857.svg"
					alt=""
				/>
				<div className="header__search">
					<SearchIcon />
					<input type="text" placeholder="Search..." />
				</div>
			</div>

			{user && (
				<div className="header__right">
					<HeaderOption Icon={HomeIcon} title="Home" />
					<HeaderOption
						Icon={SupervisorAccountIcon}
						title="My Network"
					/>
					<HeaderOption Icon={BusinessCenterIcon} title="Jobs" />
					<HeaderOption Icon={ChatIcon} title="Messaging" />
					<HeaderOption
						Icon={NotificationsIcon}
						title="Notifications"
					/>
					<HeaderOption avatar={user.photoUrl} title="Me" />
				</div>
			)}
		</div>
	);
}

export default Header;
